"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterPicker = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../../constants");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const DateFilterPicker = ({ onChangeDate }) => {
    const MINIMUM_YEAR = 2023;
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const DEFAULT_OPTION = { label: t("customerAccount.orders.datePicker.lastMonth"), value: "1" };
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(DEFAULT_OPTION);
    (0, react_1.useEffect)(() => {
        getDateFilter(selectedOption.value);
    }, [selectedOption]);
    const getDateFilter = (choice) => {
        let fromDate, toDate;
        if (Number(choice) < 12) {
            fromDate = formatFromDate(substractMonth(new Date(), Number(choice)));
            toDate = formatToDate(new Date());
        }
        else {
            fromDate = formatFromDate(new Date(Number(choice), 0, 1));
            toDate = formatToDate(new Date(Number(choice), 11, 31));
        }
        onChangeDate(fromDate, toDate);
    };
    const formatFromDate = (date) => `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 00:00:00`;
    const formatToDate = (date) => `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 23:59:59`;
    const substractMonth = (date, month) => {
        date.setMonth(date.getMonth() - month);
        return date;
    };
    const getYearsToDisplay = () => {
        const currentYear = new Date().getFullYear();
        const yearsToDisplay = [];
        for (let year = currentYear; year >= MINIMUM_YEAR; year--) {
            yearsToDisplay.push(year);
        }
        return yearsToDisplay;
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-mfp-pro-orders-dfp-container" },
        react_1.default.createElement("div", { className: "boutik-customer-account-mfp-pro-orders-dfp-label" }, t("customerAccount.orders.datePicker.label")),
        react_1.default.createElement(boutik_gatsby_plugin_components_1.ReactSelect.ReactSelectWrapper, { options: [
                DEFAULT_OPTION,
                { label: t("customerAccount.orders.datePicker.lastThreeMonth"), value: "3" },
                { label: t("customerAccount.orders.datePicker.lastSixMonth"), value: "6" },
                ...getYearsToDisplay().map((year) => ({ label: year.toString(), value: year.toString() })),
            ], onChange: (option) => setSelectedOption(option), errorMessage: { message: "", className: "", position: "bottom" }, noOptionsMessage: t("global.placeholder.reactSelectNoOptions"), value: selectedOption, styles: boutik_gatsby_plugin_components_1.ReactSelect.REACT_SELECT_WRAPPER_DEFAULT_STYLES })));
};
exports.DateFilterPicker = DateFilterPicker;
//# sourceMappingURL=DateFilterPicker.js.map